export default __webpack_public_path__ + "static/media/huma-eva-03.a6ad3275.jpg";